(function ($) {
    'use strict';

    // Toggle Sub Menu
    $( document.body ).on( 'click', 'toggle-sub-menu', function(e){
        e.preventDefault();
        $(this).next().slideToggle(300);
        $(this).toggleClass('active');
    });

    $( document.body ).on( 'click', '.burger-navigation', function(e){
        if (e.target !== this)
            return;

        $(document.body).trigger('navigation/hide');
    });

    class Menu {
        constructor() {
            $(document.body).on('click', '.menu-toggle', this.navigation_show);
            $(document.body).on('click', '.menu-close', this.navigation_hide);

            $(document).on('navigation/show', this.navigation_show);
            $(document).on('navigation/hide', this.navigation_hide);
        }

        navigation_show = () => {
            $('.burger-navigation nav').removeClass('closed');
            $(document.body).addClass('menu--visible');
        };

        navigation_hide = () => {
            $('.burger-navigation nav').addClass('closed');
            setTimeout(function(){
                $(document.body).removeClass('menu--visible');
                $('.burger-navigation nav').removeClass('closed');
            }, 500);
        };

    }

    new Menu();
}(jQuery));